import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { useAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { AUTOMATION_EXTENSION } from 'automation-ui-action-features/constants/ActionTypes';
import { createActionCardCounters, createActionMap, getActionHeaderTitle } from 'automation-ui-action-features/records/recordsUtils';
import { FLOW_BY_VERSION_ID_FIELD_NAME, GET_FLOW_BY_VERSION_ID } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
import { getEnrollmentHistoryListUrl } from 'automation-ui-canvas/utils/urls';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useQuery } from 'data-fetching-client';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const StepFilterSelectContent = ({
  currentVersionGroupFlow
}) => {
  var _extensionsData$allEx, _searchParams$get$spl, _searchParams$get;
  const isUngated = useGetIsUngated();
  const trackEvent = useTrackEvent();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const uniqueExtensionActionTypeIds = currentVersionGroupFlow ? [...new Set(Object.values(currentVersionGroupFlow.actions).filter(actionInFlow => actionInFlow.actionType === AUTOMATION_EXTENSION).map(actionInFlow => actionInFlow.actionTypeId))] : [];
  const {
    data: extensionsData,
    loading
  } = useAllExtensionDefinitions({
    objectType: currentVersionGroupFlow.objectTypeId,
    createdSourceApp: WORKFLOWS_APP,
    actionTypeIdsToInclude: uniqueExtensionActionTypeIds
  });
  const extensionDefinitions = (_extensionsData$allEx = extensionsData === null || extensionsData === void 0 ? void 0 : extensionsData.allExtensionDefinitions) !== null && _extensionsData$allEx !== void 0 ? _extensionsData$allEx : {};
  const flowActionMap = createActionMap(currentVersionGroupFlow);
  const getHeaderTitle = getActionHeaderTitle({
    flowActions: flowActionMap,
    firstActionId: currentVersionGroupFlow.firstActionId,
    extensionDefinitions,
    isUngated
  });
  const actionCardCounters = createActionCardCounters(flowActionMap, currentVersionGroupFlow.firstActionId);
  const options = Object.entries(currentVersionGroupFlow.actions).map(action => ({
    text: getHeaderTitle({
      actionId: action[1].actionId,
      useString: true
    }),
    value: action[1].actionId
  })).sort((aComparator, bComparator) => actionCardCounters[aComparator.value] - actionCardCounters[bComparator.value]);
  const currentFilteredActions = (_searchParams$get$spl = (_searchParams$get = searchParams.get('actions')) === null || _searchParams$get === void 0 || (_searchParams$get = _searchParams$get.split(',')) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.map(actionId => parseInt(actionId, 10)).sort((aComparator, bComparator) => actionCardCounters[aComparator] - actionCardCounters[bComparator])) !== null && _searchParams$get$spl !== void 0 ? _searchParams$get$spl : [];
  const handleChangeStepFilter = event => {
    const filteredActions = event.target.value;
    if (filteredActions.length === 0) {
      searchParams.delete('actions');
    } else {
      searchParams.set('actions', filteredActions);
    }
    trackEvent(Trackables.PERFORMANCE_HISTORY_FILTERS_ACTIONS);
    history.replace({
      pathname: getEnrollmentHistoryListUrl({
        flowId: currentVersionGroupFlow.flowId
      }),
      search: searchParams.toString()
    });
  };
  return /*#__PURE__*/_jsx(UISelect, {
    multi: true,
    anchorType: "button",
    onChange: handleChangeStepFilter,
    options: options,
    isLoading: loading,
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.panel.enrollment-list.filter.stepFilter.placeholder"
    }),
    value: currentFilteredActions,
    buttonUse: "form-on-dark"
  });
};
const StepFilterSelect = ({
  flowId
}) => {
  const {
    search
  } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const versionId = searchParams.get('version');
  const {
    data: {
      [FLOW_BY_VERSION_ID_FIELD_NAME]: {
        flow: currentVersionGroupFlow = null
      } = {}
    } = {},
    loading: isFlowLoading,
    error: flowError
  } = useQuery(GET_FLOW_BY_VERSION_ID, {
    skip: !versionId,
    variables: {
      flowId,
      versionId
    }
  });
  if (!isFlowLoading && (!currentVersionGroupFlow || flowError)) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.panel.enrollment-list.filter.stepFilter.label"
    }),
    className: "m-bottom-2",
    children: isFlowLoading ? /*#__PURE__*/_jsx(TFlex, {
      blockSize: "40px",
      align: "center",
      children: /*#__PURE__*/_jsx(SkeletonText, {
        backgroundColor: OLAF,
        width: 202
      })
    }) : /*#__PURE__*/_jsx(StepFilterSelectContent, {
      currentVersionGroupFlow: currentVersionGroupFlow
    })
  });
};
export default StepFilterSelect;